module.exports = __webpack_public_path__ + "static/img/veteran1.65a3a03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/scoiatael/veteran1.png
// module id = iN9f
// module chunks = 0